module.exports = __webpack_public_path__ + "img/logo.2faa9bb2.png";